import { render, staticRenderFns } from "./impersonationPanel.vue?vue&type=template&id=4782190f"
import script from "./impersonationPanel.vue?vue&type=script&lang=js"
export * from "./impersonationPanel.vue?vue&type=script&lang=js"
import style0 from "./impersonationPanel.vue?vue&type=style&index=0&id=4782190f&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/mnt/disk1/buildAgent/work/ffa2b6072150c7f8/vAnalyticsJS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4782190f')) {
      api.createRecord('4782190f', component.options)
    } else {
      api.reload('4782190f', component.options)
    }
    module.hot.accept("./impersonationPanel.vue?vue&type=template&id=4782190f", function () {
      api.rerender('4782190f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/components/nav-bar/impersonationPanel.vue"
export default component.exports